<template>
	<!-- Visa om Det finns gäster -->
	<div
		v-if="guestList().length > 0"
		class="cell small-12 medium-8 large-8 Guest_view"
	>
		<div v-for="guest in guestList()" :key="guest.guestlid">
			<ProfileGuestCard
				:hideCreate="true"
				:guestlid="guest.guestlid"
				:guestName="guest.name + ' ' + guest.lastname"
			/>
		</div>
		<ProfileGuestCard
			:guestlid="0"
			:guestName="$t('companion.createCompanionHeading')"
		/>
	</div>

	<!-- Visa om det inte finns gäster -->
	<div v-else class="cell small-12 medium-8 large-8 Guest_view">
		<div class="Guest_view__no-guests">
			<h3 class="Guest_view__title">
				{{ $t('profile.overviewGuestsSubtitle') }}
			</h3>
			<p class="Guest_view__text" v-html="$t('profile.guestText')"></p>
		</div>

		<ProfileGuestCard
			:guestlid="0"
			:guestName="$t('companion.createCompanionHeading')"
		/>
	</div>
</template>

<script>
import store from '../../vueX/store'
import ProfileGuestCard from '../../components/molecules/ProfileGuestCard'

export default {
	name: 'Guests',
	components: {
		ProfileGuestCard
	},
	data: () => {
		return {}
	},
	methods: {
		logout() {
			store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(() => {
				store
					.dispatch('DELETE_TOKEN', { token: store.state.token.refreshToken })
					.then(() => {
						this.$router.push({ name: 'login' })
					})
			})
		},
		guestList() {
			if (this.guests != null) {
				return store.state.user.guests
			} else {
				return []
			}
		}
	},
	computed: {
		guests() {
			if (store.state.user != null) {
				return store.state.user.guests
			}
			return []
		}
	}
}
</script>

<style scoped lang="scss">
.Guest_view {
	@include profile-background;
	&__wrapper {
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
		padding: 20px;
		background: #fff;
	}
	&__label {
		margin-bottom: 10px;
		color: $colorPrimary;
		display: flex;
		align-items: center;
	}

	&__tabs {
		margin-bottom: 20px;
	}

	&__tabView {
		text-align: left;
	}

	&__input {
		display: flex;
		flex-direction: column;
		margin-top: 10px;
	}

	&__back {
		text-align: center;
		margin-top: 30px;
		font-size: 20px;
	}

	.info {
		width: 24px;
		height: 24px;
		margin-left: 10px;
		fill: $colorPrimary6;

		&:hover {
			cursor: pointer;
			fill: $colorSecondary;
		}
	}

	&__no-guests {
		border-top: 0;
		background-color: $colorWhite;
		padding: 60px;
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
	}
	&__title {
		border-bottom: 1px solid $colorPrimary2;
		padding-bottom: 25px;
	}
	&__text {
		margin: 20px 0;
	}
}
</style>
